import React from 'react';
import { motion } from 'framer-motion';
import { services } from '../data/content';
import { serviceIconMap, ArrowRightIcon } from './icons/LineIcons';
import { SectionHeading } from './SectionHeading';
export function Services() {
  return <section id="servicios" className="relative w-full bg-graphite py-20 sm:py-24 lg:py-32" aria-labelledby="servicios-title" data-id="element-323" data-mp="1ds7p2r5yf5y8">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 hidden h-56 w-[60%] -translate-x-1/2 bg-gold/[0.05] blur-3xl lg:block" data-id="element-324" data-mp="13wegtjz9pym9" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-10" data-id="element-325" data-mp="u61nb29h6v3z">
        <SectionHeading eyebrow="Servicios" title={<span id="servicios-title" data-id="element-327" data-mp="q5hozvd61lg9">
              Lo que hago <span className="text-gold" data-id="element-328" data-mp="l5dj0z9vw94a">frente</span> y detrás de
              cámara
            </span>} description="Cada proyecto se construye sobre una idea clara, una narrativa cuidada y una ejecución de estándar profesional." data-id="element-326" data-mp="u6bdoqyfn4a7" />

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3" data-id="element-329" data-mp="36awq2k20032c">
          {services.map((service, index) => {
          const Icon = serviceIconMap[service.icon];
          return <motion.li key={service.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.5,
            delay: index * 0.06,
            ease: 'easeOut'
          }} className="group relative overflow-hidden rounded-card border border-white/[0.07] bg-anthracite p-7 transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-[0_24px_60px_-30px_rgba(245,197,24,0.4)]" data-id="element-330" data-mp="2xdme0whcw9wd" data-mpi={index}>
                <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-gold/0 blur-3xl transition-all duration-500 group-hover:bg-gold/10" data-id="element-331" data-mp="24mkqa6zll618" />
                <span className="relative grid h-12 w-12 place-items-center rounded-md border border-gold/25 bg-ink text-gold transition-colors duration-300 group-hover:border-gold/60" data-id="element-332" data-mp="1pjayhpmhc5zd">
                  <Icon className="h-6 w-6" data-id="element-333" data-mp="1gq7oxseygda0" />
                </span>
                <h3 className="relative mt-6 font-display text-xl uppercase tracking-wide text-white" data-id="element-334" data-mp="1bthbzdyg5xst">
                  {service.title}
                </h3>
                <p className="relative mt-3 text-sm leading-relaxed text-ash" data-id="element-335" data-mp="16r8f46igeblf">
                  {service.description}
                </p>
                <span aria-hidden="true" className="relative mt-6 flex h-px w-full bg-gradient-to-r from-gold/40 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-336" data-mp="xs4v90bgps5v" />
              </motion.li>;
        })}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.5
      }} className="mt-12 flex justify-start" data-id="element-337" data-mp="2n95v1u8kycoc">
          <a href="#reunion" className="group inline-flex items-center gap-3 font-sans text-sm font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-338" data-mp="34hfa1pq3g50k">
            Conversemos sobre tu proyecto
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" data-id="element-339" data-mp="2btjg2srwsr7h" />
          </a>
        </motion.div>
      </div>
    </section>;
}